/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2020-10-13 11:29:41
 * @LastEditors: Sam
 * @Description: 
 * @FilePath: \thework\tofba-client\src\router\modules\financialManagement.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
import Layout from '@/layout/index.vue'

const financialManagementRouter = {
  path: '/financialManagement',
  component: Layout,
  redirect: 'noredirect',
  name: 'FinancialManagement',
  meta: {
    title: 'financialManagement',
    icon: 'finance-line'
  },
  children: [
    {
      path: 'quickRepayment',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/financialManagement/quickRepayment.vue'
        ),
      name: 'QuickRepayment',
      meta: {
        title: 'quickRepayment',
        noCache: true
      }
    },
    {
      path: 'flowRecord',
      component: () =>
        import(/* webpackChunkName: "bar-chart" */ '@/views/financialManagement/flowRecord.vue'),
      name: 'FlowRecord',
      meta: {
        title: 'flowRecord',
        noCache: true
      }
    }
  ]
}

export default financialManagementRouter
